import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5f3ac2b1&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style1 from "./Index.vue?vue&type=style&index=1&id=5f3ac2b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ac2b1",
  null
  
)

export default component.exports